import styled from 'styled-components';
import {
  ButtonBase,
  BaseColumnWrap,
} from '../../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import {textSizes} from '@stencil/build-theme';

export const AddBtn = styled(ButtonBase)`
  ${textSizes.MediumW3}
  background-color: ${props => props.bgColor || props.theme.colors.goWhite.base};
  border: 0.1rem solid ${props => props.theme.colors.goBrandOrange.base};
  width: fit-content;
  margin-top: ${props => props.theme.spacing.base};
  margin-bottom: ${props => props.theme.spacing.base};
  color: ${props => props.theme.colors.goBrandOrange.base};
  padding: ${props => props.theme.spacing.base};
  border-radius: ${props => props.theme.misc.borderRadius.custom(30)};
  text-transform: capitalize;
  &:disabled {
    background-color: ${props => props.theme.colors.downriver.light};
    border: 0.1rem solid ${props => props.theme.colors.downriver.light};
    cursor: not-allowed;
  }
`;

export const AddBtnOuterWrapper = styled.div(
  props => `
    width:100%;
    display:flex;
    position:relative;
    justify-content: flex-end;
    `,
);

export const RoomUpgradeBtn = styled(ButtonBase)`
  ${textSizes.MediumW3}
  display:flex;
  flex-direction: column;
  width: 66%;
  margin-top: ${props => props.theme.spacing.base};
  margin-bottom: ${props => props.theme.spacing.base};
  padding: ${props => props.theme.spacing.base};
  border-radius: ${props => props.theme.misc.borderRadius.custom(30)};
`;
export const FlexItemCenter = styled.div(
  props => `
      display:flex;
      align-items: ${props.alignitem || 'center'};
      `,
);

export const RoomUpgradeUpperWrapper = styled(FlexItemCenter)(
  props => `
    // padding-bottom:${props.theme.spacing.base}
    `,
);

export const PaxCountSpan = styled.span(
  props => `
      color:${props.theme.colors.goWhite.base};
      `,
);
